/**
 * Customize to take the adjustments
 */

import { UnitPriceDisplay } from '@/components/blocks/UnitPriceDisplay';
import { OrderItemTableRowData } from '@/components/content/OrderItemTable/parts/Table';
import { useOrderItemTableRow } from '@/data/Content/OrderItemTable';
import { ContentContext } from '@/data/context/content';
import { FC, useContext } from 'react';

export const OrderItemUnitPrice: FC = () => {
	const {
		details: { prices },
		price: { totalAdjustment, orderItemPrice, currency },
	} = useContext(ContentContext) as OrderItemTableRowData & ReturnType<typeof useOrderItemTableRow>;
	const unitPrice = totalAdjustment
		? Number(orderItemPrice) + Number(totalAdjustment.value)
		: orderItemPrice;
	return (
		<UnitPriceDisplay
			unitPriceCurrency={currency}
			unitPrice={unitPrice.toString()}
			prices={prices}
		/>
	);
};
